import styled from 'styled-components';

const StyledWeatherIcon = styled.img`
	width: 16px;
	height: 16px;
	user-select: none;
	pointer-events: none;
`;

export { StyledWeatherIcon };
